declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { FDService } from '../../../../services/fd.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FDActorDocRequest, FdActorReportsDocController, FDSectionRequest, FdSectionsController, FDActorReportDetailsDocRequest, FdActorDocReportDetailsController, FdActorDocReportDetailsBySectionCode } from '../../../../models/formdesign/fd.model';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { DBOperation } from '../../../../enums/enum';
import { NgbActorFormsModal } from '../modals/actorforms.modal';
//import { CustomCodeValuesController, CustomCodeTypeRequest } from '../../../../CustomDataByRequestType.interface';
//import { CUstomDataByRequestTypeService } from './CustomDataByRequestType.service';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

import { GaugeComponent } from '@swimlane/ngx-charts';
import { CustomCodeTypeRequest_, CustomCodeValuesController_} from '../../../../models/master/mastermodel';
import { CataloguePipe } from '../../../../pipes/masters/credentialtype.pipe';
import { NameValuePair, SectionQA } from '../version3/forms/actorformsv3.component';



//export class SectionQA {
//  public Title: string;
//  public Questions: FdActorDocReportDetailsController[];
 
//}
//export class NameValuePair {
//  name: string;
//  value: number;
//}

@Component({
  selector: 'actorvitalform',
  templateUrl: './actorvitalform.component.html',
  styleUrls: ['./actorvitalform.component.scss']
  , animations: [routerTransition()]
})

export class ActorVitalFormComponent implements OnInit {

  view: any[] = [300, 200];
  colorScheme = {
    domain: ['#bf9d76', '#e99450', '#d89f59', '#f2dfa7', '##a5d7c6', '#7794b1']
  };


  CurrentFDActorDocRequest: FDActorDocRequest;

  @Input() ActorCode: number;
  @Input() ActorType: number;
  @Input() ReportType: string = "";
  @Input() ResultType: string = "";

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public ActorReportTemplateCode: number = 0;

  public IsShowActorFormList: boolean =true;
  public IsRateing: boolean = false;

  CurrentFdActorReportsDocController: FdActorReportsDocController[];

  public ActorReportCode: number = 0;
  public SectionCode: number = 0;
  public TemplateName: string;
  public SectionName: string;
  
  GetChartData(source: FdActorReportsDocController) {

    var data: any[] = new Array <NameValuePair>();

    var pair: NameValuePair;
    pair = new NameValuePair();
    pair.name = source.TemplateName;
    pair.value = source.ScorePercent;
    
    data.push(pair);

    return data;

  }

  ShowSkillsList: boolean  = true;
  ShowQuestionnaire: boolean;




  /// to show skills and hide quesstions
  ShowSkills() {
    var s: boolean = true;
    this.ShowSkillsList = s;
    this.ShowQuestionnaire = !s;
  }
  // to show questions and hide skills
  ShowQuestions() {
    var s: boolean = true;
    this.ShowSkillsList = !s;
    this.ShowQuestionnaire = s;
  }
  //
  CurrentFDSectionRequest: FDSectionRequest;
  CurrentFdSectionsController: FdSectionsController[];

  //
  CurrentFDActorReportDetailsDocRequest: FDActorReportDetailsDocRequest;
  CurrentFdActorDocReportDetailsController: FdActorDocReportDetailsController[];
  CurrentFdActorDocReportDetailsBySectionCode: FdActorDocReportDetailsBySectionCode;
  SelectedQA: SectionQA[];


  // For Search
  pdata: any[];// = this.data;
  listFilter: string;
  searchTitle: string = "Search:";

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private fdservice: FDService,
    private modalService: NgbModal, private tosterservice: NGXToastrService,
    private filter: CataloguePipe) { }


  ngOnInit() {
    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.ActorCode > 0) {
      this.CurrentFDActorDocRequest.ActorCode = this.ActorCode;
    }
    else {
      this.CurrentFDActorDocRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    if (this.ReportType === "")
    {
      if (AppData.Instance().UserLoginDetails.UserType = 3) {
        this.ReportType ="Nurse"
      }
      else if (AppData.Instance().UserLoginDetails.UserType = 13) {
        this.ReportType = "Registry"
      }
      else if (AppData.Instance().UserLoginDetails.UserType = 14) {
        this.ReportType = "Registry"
      }
    }
    if (this.ResultType === "") {
      this.ResultType ="Rateing"
    }
   
    
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;

    this.CurrentFdActorReportsDocController = new Array<FdActorReportsDocController>();



    this.CurrentFDSectionRequest = new FDSectionRequest();
    this.CurrentFDSectionRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentFdSectionsController = new Array<FdSectionsController>();


//
    //this.CurrentFdActorDocReportDetailsController = new Array<FdActorDocReportDetailsController>();
    //this.SelectedQA = new Array<SectionQA>();


    this.CurrentFDActorReportDetailsDocRequest = new FDActorReportDetailsDocRequest();
    this.CurrentFDActorReportDetailsDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentFDActorReportDetailsDocRequest.FdActorDocReportDetailsController = new Array<FdActorDocReportDetailsController>();
    //
    this.CurrentFdActorDocReportDetailsBySectionCode = new FdActorDocReportDetailsBySectionCode();
    this.CurrentFdActorDocReportDetailsBySectionCode.SendApiRequestModel = AppData.Instance().ApiRequestParms;

//


    this.LoadSkillsCatalogue();

  }
  //Search
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentCustomCodeValuesController;
    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentCustomCodeValuesController, this.listFilter);
      }
    }
  }
  //criteriaChange2(value: any) {
  //  if (this.filter != null) {
  //    if (value != '[object Event]') {
  //      this.listFilter = value;
  //      //alert(this.listFilter);
  //      this.pdata = this.filter.transform(this.CurrentFdActorReportsDocController,
  //        this.listFilter);
  //    }
  //  }
  //}
  ShowActorFormList() {
    if (this.IsShowActorFormList === true) {
      this.IsShowActorFormList = false;

    }
    else {
      this.IsShowActorFormList = true;
    }
 
  }

  GetFdActorReportsDocController() {
    this.StartRefreshing();
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentFdActorReportsDocController = this.ApiResData.Result;
          this.SectionCode = 0;

          this.initGridButton();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }



  GetFdActorReportsDocControllerWithOutSectionRefresh() {
    //alert(this.GetFdActorReportsDocControllerWithOutSectionRefresh);
    this.StartRefreshing();
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentFdActorReportsDocController = this.ApiResData.Result;
          //this.SectionCode = 0;

          //this.initGridButton();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  Edit_(Event: any) {

    this.ShowQuestions();

    this.ActorReportCode = parseInt(Event);

    this.CurrentFDActorDocRequest.ActorReportCode = this.ActorReportCode;

    var CurrentFdActorReportsDocControllerByCode = this.CurrentFdActorReportsDocController.filter(x => x.ActorReportCode === parseInt(Event));
    if (CurrentFdActorReportsDocControllerByCode.length > 0) {
      this.CurrentFDSectionRequest.BodyCode = CurrentFdActorReportsDocControllerByCode[0].TemplateBodyCode;
      this.TemplateName = CurrentFdActorReportsDocControllerByCode[0].TemplateName;
      if (CurrentFdActorReportsDocControllerByCode[0].ResultType === this.ResultType) {
        //"Rateing"
        this.IsRateing = true;
      }
      else {
        this.IsRateing = false;
      }

      this.CurrentFDActorDocRequest.ActorReportCode = this.ActorReportCode;
      //eranki
      this.GetFdSectionsController();
      // alertFunctions.ShowSuccess('Sections Load', 'initiated' );

     this.GetFdActorDocReportDetailsController();


    }
    else {
      this.CurrentFDSectionRequest.BodyCode = 0;

    }



  }
  @Input() RequestedType: string;
  @Input() public FacilityCode: number = 0;
  //@Input() public ActorCode: number = 0;
  @Input() public CustomCode: number = 0;
  @Input() public CustomType: string = "0";
  @Input() public StringContains: string = "0";
  CurrentCustomCodeTypeRequest: CustomCodeTypeRequest_;
  CurrentCustomCodeValuesController: CustomCodeValuesController_[];
  LoadSkillsCatalogue() {

    this.RequestedType = "FDTemplateWithTypeByActorReportTemlateCode";

    this.CurrentCustomCodeTypeRequest = new CustomCodeTypeRequest_();
    this.CurrentCustomCodeTypeRequest.RequestedType = this.RequestedType;
    this.CurrentCustomCodeTypeRequest.FacilityCode = this.FacilityCode;
    this.CurrentCustomCodeTypeRequest.ActorCode = this.ActorCode;
    this.CurrentCustomCodeTypeRequest.CustomCode = this.CustomCode;
    this.CurrentCustomCodeTypeRequest.CustomType = this.ReportType;
    this.CurrentCustomCodeTypeRequest.StringContains = this.StringContains;
    this.CurrentCustomCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;


    this.CurrentCustomCodeValuesController = new Array<CustomCodeValuesController_>();

    this.RequestedTypeValueByType();
  }

  RequestedTypeValueByType(): void {
    this.StartRefreshing();

    this.fdservice.GetCustomDataByRequestedType_(this.CurrentCustomCodeTypeRequest).subscribe
      (

      (result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentCustomCodeValuesController = this.ApiResData.Result;
          this.CurrentCustomCodeValuesController.splice(0, 1);
          this.pdata = this.CurrentCustomCodeValuesController;
          this.stopRefreshing();

          this.GetFdActorReportsDocController();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            alert(' Failed Due to Internal Error.... Please Contact Admin..');
          }
        }

      },
      (error) => {

        if (error == "401 - Unauthorized") {
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
        }
      }
      //
      );;

  }
  onChangeTemplate(Event: any) {
    this.SectionCode = 0;
    this.ActorReportCode = parseInt(Event);

    //
    var CurrentFdActorReportsDocControllerByCode = this.CurrentFdActorReportsDocController.filter(x => x.ActorReportCode === parseInt(Event));
    if (CurrentFdActorReportsDocControllerByCode.length > 0) {
      this.CurrentFDSectionRequest.BodyCode = CurrentFdActorReportsDocControllerByCode[0].TemplateBodyCode;
      this.TemplateName = CurrentFdActorReportsDocControllerByCode[0].TemplateName;
      if (CurrentFdActorReportsDocControllerByCode[0].ResultType === this.ResultType) {
        //"Rateing"
        this.IsRateing = true;
      }
      else {
        this.IsRateing = false;
      }
     
      this.CurrentFDActorDocRequest.ActorReportCode = this.ActorReportCode;
      //eranki
      this.GetFdSectionsController();
     // alertFunctions.ShowSuccess('Sections Load', 'initiated' );
      
      //this.GetFdActorDocReportDetailsController();
    

    }
    else {
      this.CurrentFDSectionRequest.BodyCode = 0;
  
    }


  }

  IsSectionAdded(title: string) {
    //eranki
    this.SelectedQA.forEach(function (value) {
      if (title == value.Title)
        return true;
    });

      return  false;
  }
  //function (isSameSection(element, index, array))
  GroupQA(section: FdSectionsController) {
   // alertFunctions.ShowSuccess('Grouping  section : ', '' + section.SectionTitle);
    this.CurrentFdActorDocReportDetailsController.forEach(function (qa) {
      if (qa.SectionTitle == section.SectionTitle) {
       // alertFunctions.ShowSuccess('Check  section Exists', '' + qa.SectionTitle);
        // check if section is aready added..
        if (!this.IsSectionAdded(qa.SectionTitle)) {
        //  alertFunctions.ShowSuccess('Add section', '' + qa.SectionTitle);
          // else create section gruop
          var sectionQA: SectionQA = new SectionQA();
          sectionQA.Questions = new Array<FdActorDocReportDetailsController>();
          sectionQA.Title = qa.SectionTitle;
          sectionQA.Questions.push(qa);
          this.SelectedQA.push(sectionQA);

        }
        else {
          this.SelectedQA.forEach(function (value) {
            /// selected section
            if (section.SectionTitle == value.Title) {
              // add element to it
              this.value.push(qa);
            }
          });
        }

        
      }


    });
  }

  
  GetFdActorDocReportDetailsController() {

    this.StartRefreshing();
    this.fdservice.GetFdActorDocReportDetailsController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
         // alert("sastr");
          //    alert(this.ApiResData.Result);
          var qas = new Array<SectionQA>();
          this.CurrentFdSectionsController.forEach(function (value) {
            var sectionQA: SectionQA = new SectionQA();
            sectionQA.Questions = new Array<FdActorDocReportDetailsController>();
            sectionQA.Title = value.SectionTitle;
            qas.push(sectionQA);
            //    alert(sectionQA.Title);
          });
          this.SelectedQA = qas;
          //  alertFunctions.ShowSuccess('init grouping', this.ApiResData.Result[0]);
          this.CurrentFdActorDocReportDetailsController = this.ApiResData.Result;
          //  alert(this.CurrentFdActorDocReportDetailsController.length.toString() + " is total qs");
          // alert(this.CurrentFdActorDocReportDetailsController);
          //  this.CurrentFdActorDocReportDetailsController.length.toString());
          //  console.log('CurrentFdActorDocReportDetailsController--->' + this.CurrentFdActorDocReportDetailsController[0].CanShowTitle);


          //  this.CurrentFdSectionsController.forEach(function (value) {
        
         //   alert(this.CurrentFdActorDocReportDetailsController.length.toString() + " is total qs");

          //for (let value of this.CurrentFdSectionsController) {
          //  var section = value;
 

            for (let qa of this.CurrentFdActorDocReportDetailsController) {

             // this.CurrentFdActorDocReportDetailsController.forEach(function (qa) {
                //alert(qa.);
             //   alertFunctions.ShowSuccess('to Check  section Exists', '' + qa.SectionTitle);
                //if (qa.SectionTitle == section.SectionTitle) {
                //  // check if section is aready added..
                //  if (!this.IsSectionAdded(qa.SectionTitle)) {
                //    alertFunctions.ShowSuccess('Add section', '' + qa.SectionTitle);
                //    // else create section gruop
                //    var sectionQAA: SectionQA = new SectionQA();
                //    sectionQAA.Questions = new Array<FdActorDocReportDetailsController>();
                //    sectionQAA.Title = qa.SectionTitle;
                //    sectionQAA.Questions.push(qa);
                //    this.SelectedQA.push(sectionQAA);

                //  }
                //  else
                {
                  //  alertFunctions.ShowSuccess('section already Exists', '' + qa.SectionTitle);
                  // this.SelectedQA.forEach(function (value) {
                for (let p of this.SelectedQA)
                {


                  /// selected section
                  if (qa.SectionTitle == p.Title) {
                      // add element to it
                      p.Questions.push(qa);
                    }
                    //});
                  }

                }
                }

             // }
            
         // alertFunctions.ShowSuccess('Ques grouped', '' + this.SelectedQA.length);

        }
        
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }



  public SaveFDActorDocReportDetails() {
    this.StartRefreshing();
    this.CurrentFDActorReportDetailsDocRequest.FdActorDocReportDetailsController = this.CurrentFdActorDocReportDetailsController;
    this.fdservice.SaveFDActorDocReportDetails(this.CurrentFDActorReportDetailsDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            this.GetFdActorReportsDocControllerWithOutSectionRefresh();

            //alertFunctions.ShowSuccess('Success', 'Save operation completed successfully.');
            this.tosterservice.ToasterSuccessAlertParam('Save operation completed successfully.....!');
            this.pdata = this.filter.transform(this.CurrentCustomCodeValuesController, '');
            this.ShowSkills();

            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  GetFdSectionsController() {
    this.StartRefreshing();
    this.fdservice.GetFdSectionsController(this.CurrentFDSectionRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentFdSectionsController = this.ApiResData.Result;
          //this.initGridButton();
          //  alertFunctions.ShowSuccess('Sections Loaded', 'sections = ' + this.CurrentFdSectionsController.length);
          if (this.ApiResData.Result.length > 0) {
            this.GetFdActorDocReportDetailsController();
          }

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }

  //
  //

  public onSubmitTemplate() {
    if (this.ActorReportTemplateCode > 0) {
      this.StartRefreshing();
      this.CurrentFDActorDocRequest.ConditionalOperator = 1;
      this.CurrentFDActorDocRequest.ActorReportTemplateCode = this.ActorReportTemplateCode;

      this.fdservice.SaveFdActorReportDoc(this.CurrentFDActorDocRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            if (this.ApiResData.Result > 0) {

              //this.GetFdActorReportsDocController();

              //alertFunctions.AlertParam('Saved Successfully.....!');
              this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

              this.ShowSkills();

              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParam("Invalid Operation...!");


              this.stopRefreshing();

            }

          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



            }
            else {
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
              //this.activeModal.close();
            }
          }

        },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            // this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            this.stopRefreshing();
          }
        }
        );
    }
    else {
      alertFunctions.AlertParam('Please Select Template Properly...!');
    }
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  //
  isREADONLY: boolean = false;
  exportFileName: string = "FdActorReportForms_";
  dbops: DBOperation;


  columns: any[] = [

    {
      display: 'Certificate',
      variable: 'TemplateName',
      filter: 'text'
    },
    {
      display: 'Applies To',
      variable: 'ReportType',
      filter: 'text'
    },
     {
       display: 'Score',
       variable: 'ResultType',
      filter: 'text'
    }
    
    ,
    {
      display: 'Date',
      variable: 'Date',
      filter: 'date'
    }

  ];
  sorting: any = {
    column: 'Date',
    descending: false
  };
  hdrbtns: any[] = [];
  gridbtns: any[] = [];
  initGridButton() {

    this.hdrbtns = [
      {
        title: 'Add',
        keys: [''],
        action: DBOperation.create,
        ishide: false

      }];

    this.gridbtns = [
      {
        title: 'Remove',
        keys: ["ActorReportCode"],
        action: DBOperation.delete,
        ishide: false
      },


    ];

  }
  //Grid Vars end
  gridaction(gridaction: any): void {

    switch (gridaction.action) {

      case DBOperation.create:
        // alertFunctions.AlertParam('add')
        this.openNewContent();

        break;

      case DBOperation.delete:
        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0CC27E',
          cancelButtonColor: '#FF586B',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonClass: 'btn btn-success btn-raised mr-5',
          cancelButtonClass: 'btn btn-danger btn-raised',
          buttonsStyling: false
        }).then(() => {



          this.DeleteActorFormByCode(gridaction.values[0].value);

        }, function (dismiss) {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              'Delete Operation Cancelled :)',
              'error'
            )
          }
        })


        break;

       
    }
  }
  del_(ActorReportCode: any) {

    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorFormByCode(ActorReportCode);

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }

  //
  DeleteActorFormByCode(ActorReportCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentFDActorDocRequest.ConditionalOperator = 3;
    this.CurrentFDActorDocRequest.ActorReportCode = ActorReportCode;
    this.fdservice.SaveFdActorReportDoc(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

          ;
            //alertFunctions.AlertParam('Delete Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');



            this.stopRefreshing();
            this.CurrentFdActorDocReportDetailsController = new Array<FdActorDocReportDetailsController>();
            this.ActorReportCode = 0;
            this.GetFdActorReportsDocController();
        
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  //
  openNewContent() {
    const modalRef = this.modalService.open(NgbActorFormsModal,
      {
        centered: true
      })
    modalRef.componentInstance.ReportType = this.ReportType;
    modalRef.result.then(x => { this.GetFdActorReportsDocController() })

  }

  CheckIfSkillExists(l: CustomCodeValuesController_): boolean {
    //alert(l.DisplayName);
    var x =
      this.CurrentFdActorReportsDocController
        .filter(x => x.TemplateName == l.DisplayName);
    if (x.length > 0)
      return true;
    else
      return false;


  }

  public ConfirmAndProceedToAddSkill(l: CustomCodeValuesController_) {

    if (this.CheckIfSkillExists(l)) {

      this.tosterservice.ToasterSuccessAlertParam('You already have this skill in your profile');

      return;
    }
    else {

      swal({
        title: 'Confirm Action',
        text: "Would you like to add the selected skill set to your profile",
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#0CC27E',
        cancelButtonColor: '#FF586B',
        confirmButtonText: 'Yes, Add Skill',
        cancelButtonText: 'No, cancel!',
        confirmButtonClass: 'btn btn-success btn-raised mr-5',
        cancelButtonClass: 'btn btn-danger btn-raised',
        buttonsStyling: false
      }).then(() => {


        this.AddSkillToMyList(l.Code);


        }, function (dismiss) {
          this.tosterservice.ToasterSuccessAlertParam
            ('selected operation cancelled..!');

        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        //if (dismiss === 'cancel') {
        //  swal(
        //    'Cancelled',
        //    'operation cancelled)',
        //    'error'
        //  )
        //}
      })
    }
  }

  displayCatalogue;
  public AddSkillToMyList(ActorReportTemplateCode: number) {
    if (ActorReportTemplateCode > 0) {
      this.StartRefreshing();
      this.CurrentFDActorDocRequest.ConditionalOperator = 1;
      this.CurrentFDActorDocRequest.ActorReportTemplateCode = ActorReportTemplateCode;

      this.fdservice.SaveFdActorReportDoc(this.CurrentFDActorDocRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            if (this.ApiResData.Result > 0) {

              // alertFunctions.AlertParam('Saved Successfully.....!');
              this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
              this.stopRefreshing();
              this.CurrentFDActorDocRequest.ConditionalOperator = 1; // get
              this.GetFdActorReportsDocController();

              
            }
            else {
              alertFunctions.AlertParam("Invalid Operation...!");


              this.stopRefreshing(); 
            }

          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData); 



            }
            else {
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
              
            }
          }

        },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
         
            this.stopRefreshing();
          }
        }
        );
    }
    else {
      alertFunctions.AlertParam('Please Select Template Properly...!');
    }
  }
  CancelUpdateOperation() {
    this.pdata = this.filter.transform(this.CurrentCustomCodeValuesController, '');
    this.ShowSkills();
  }

}
